// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_tMF","label":"styles_label__2Mo9X"};